export class CellValidState {

    valid;
    /**
     * css
     */
    className;
    message;

    constructor(valid, className, message) {
        this.valid = valid;
        this.className = className;
        this.message = message;
    }
}
